import styled, { css } from 'styled-components';
import { getTypographyStyles, getMargins, typographyTokenMapping, SYS_SIZE_FIXED_50 } from '@oneaudi/unified-web-alpha-common';
export const FootnoteStyle = css `
  sup {
    vertical-align: 0.68em;
  }

  sub {
    vertical-align: -0.275em;
  }

  sup,
  sub {
    font-size: 0.583em;

    a {
      color: inherit;
      text-decoration: none;
      border-bottom: ${SYS_SIZE_FIXED_50} solid
        ${(props) => props.theme.cmp.color.navigation.textLink.foreground.default};

      transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
      transition-duration: 250ms;
      transition-property: color, border-color;

      &:hover {
        color: ${(props) => props.theme.cmp.color.navigation.textLink.foreground.interactive};
        border-bottom-color: ${(props) => props.theme.cmp.color.navigation.textLink.foreground.interactive};
      }
      border-bottom: none;
    }
  }
`;
export const StyledText = styled.div `
  margin: ${(props) => getMargins(props.margin) || 0};
  color: ${(props) => props.theme.sys.color.text.copy.default};
  text-align: ${(props) => props.$textAlign};

  ${(props) => {
    const { order, style } = props.variant;
    const token = typographyTokenMapping.sys.typography.copy.order[order][style];
    return css `
      ${getTypographyStyles(token)}
    `;
}};

  ${FootnoteStyle}
`;
//# sourceMappingURL=index.styles.js.map